import { IconButton } from 'rsuite';
import styled, { css } from 'styled-components';
import theme from '~/styles/theme';

export const ButtonIcon = styled(IconButton)`
  display: flex;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;

  @media (max-width: 1366px) {
    right: 115px;
  }
`;

export const InCityToggle = styled.div`
  .rs-toggle-checked .rs-toggle-presentation {
    background-color: ${theme.darkGreen};
  }
  ${(props) =>
    props.darkMode
      ? css`
          .rs-toggle-presentation {
            background: ${theme.darkGray};
          }
        `
      : css`
          .rs-toggle-presentation {
            background: ${theme.lightGray};
          }
        `}
`;
